import { LanguageSelect } from 'imaginarity-react-ui';
import { rootElement } from 'index';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Actions } from 'services/ApplicationState/Actions';
import { ApplicationState, useAppDispatch } from 'services/ApplicationState/ApplicationState';
import { languages as lngs } from 'services/Config';
import { shallowCompare } from 'services/Helpers';
import { useImgI18N } from 'services/ImgI18N';
import { ThemeContext } from 'styled-components';
import { createFilledStyles } from 'views/Workflow/State/Operations/CopyToGroupWorkflowTransitionOperation';
import * as _ from "lodash";

const mapper = (state: ApplicationState) => ({
    contentLanguage: state.contentLanguage,
    currentGroup: state.currentGroup
});

interface ContentLanguageSelectProps {
    languages?: string[];
    menuPortalTarget?: HTMLElement | null;
    isDisabled?: boolean;
    onSelect?: (lng: string) => void;
    language?: string;
    noRoot?: boolean;
    color?: string;
    dropUp?: boolean;
    maxMenuHeight?: number;
    menuShouldBlockScroll?: boolean;
}

const ContentLanguageSelect = (p: ContentLanguageSelectProps) => {
    const { onSelect, languages, isDisabled, noRoot, language, color, dropUp, maxMenuHeight, menuShouldBlockScroll } = p
    const dispatch = useAppDispatch();
    const { contentLanguage, currentGroup } = useSelector(mapper, shallowCompare);
    const { currentLanguage, t } = useImgI18N("general");
    const theme = React.useContext(ThemeContext);

    const emptyStyles = React.useMemo(() => createFilledStyles(theme, false, color, [5, 0, 10, 0]), [theme, color]);

    const lng = language ?? (contentLanguage ?? currentLanguage);

    const update = React.useMemo(() => (lng: string) => {

        if (onSelect)
            onSelect(lng);
        else
            dispatch(Actions.setContentLanguage(lng));
    }, [dispatch, onSelect]);

    const lngToSelect = React.useMemo(() => {
        const lngRes = currentGroup?.attributes?.["languageRestriction"];
        const toRet = languages ?? lngs;
        if (lngRes && lngRes.length > 0)
            return _.filter(toRet, l => lngRes.includes(l));
        return toRet;
    }, [languages, currentGroup]);

    if (_.findIndex(lngToSelect, l => l === lng) < 0 && lngToSelect.length > 0) {
        // Current language not in list, select first one
        update(lngToSelect[0]);
    }

    return (
        <LanguageSelect
            languageList={lngToSelect}
            onChange={update as any}
            value={lng}
            translationFunction={t}
            menuPortalTarget={noRoot ? undefined : rootElement}
            isDisabled={isDisabled}
            styles={color !== undefined ? emptyStyles : undefined}
            dropUp={dropUp ?? false}
            maxMenuHeight={maxMenuHeight}
            menuShouldBlockScroll={menuShouldBlockScroll}
        //isMulti={true}
        />
    );
}
export default ContentLanguageSelect;